export const MOVIDA_POINTS_PROGRAM =
    "Earn 1% back in MOVIDA Points every time you charter a private jet or helicopter with SHY Aviation. Each point is worth £1 and can be redeemed against future flights, luxury transfers, or exclusive SHY Lifestyle services.";

export const FUEL_STOP_INFO =
    "This quotation includes a planned fuel stop, which may add approximately 45 minutes to 1 hour to total travel time depending on airport traffic and ground operations. Passengers are typically not required to disembark.";
